import { FormikHelpers } from 'formik';
import { Wysiwyg, WysiwygProps } from 'components/UI/Wysiwyg';

export type FormWysiwygProps = WysiwygProps & Pick<FormikHelpers<unknown>, 'setFieldValue'>;

const FormWysiwyg = ({ setFieldValue, ...props }: FormWysiwygProps) => (
  <Wysiwyg {...props} onChange={(name, value) => setFieldValue(name, value)} />
);

export { FormWysiwyg };
